/*jslint white: true, nomen: true */
/*global angular */
(function() {
  'use strict';

  angular.module('app.forms')
    .directive('formComponentOwnershipStatusSelect', [function() {
      return {
        restrict: 'E',
        templateUrl: 'form-component-ownership-status-select',
        replace: true,
        scope: {
          defaultPlaceholder: '@',
          model: '=',
          formObj: '=',
          formScope: '=',
          selectName: '=?',
          isRequired: '=?'
        },
        bindToController: true,
        controllerAs: 'vm',
        link: function() {},
        controller: [function() {
          var self = this;

          if (! self.defaultPlaceholder) {
            self.defaultPlaceholder = 'Current Ownership Status';
          }
          if (! self.selectName) {
            self.selectName = 'ownership_status';
          }

          if (typeof self.isRequired === 'undefined') {
            self.isRequired = true;
          }

          self.methods = ['Own a Home', 'Rent a Home', 'Live with Family'];

        }]
      };

    }]);
}());